import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Table } from "react-bootstrap";
// import { Form } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";

const TableForm = (props) => {
  const [tableData, setTableData] = useState([
    {
      number: "1",
      designation: "",
      quantity: "",
      observation: "",
      availability: false,
    },
  ]);
  const [numberOfItems, setNumberOfItems] = useState(1);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Submit the form data to your backend server here.
  };

  const handleChange = (e) => {
    const rowIndex = e.target.getAttribute("data-row-index");
    const fieldName = e.target.name;
    const value = e.target.value;

    const updatedTableData = [...tableData];
    updatedTableData[rowIndex][fieldName] = value;

    setTableData(updatedTableData);

    props.onTableDataChange(updatedTableData); 

  };

  const handleAddRow = () => {
    setNumberOfItems((previousNumberOfItems) => previousNumberOfItems + 1);
    const newRow = { number: numberOfItems + 1, designation: "", quantity: "", observation: "" };
    setTableData([...tableData, newRow]);
  };

  const renderTable = () => {
    return (
      <table className='table'>
        <thead>
          <tr>
            <th className='col-sm-1'>No.</th>
            <th className='col-sm-5'>Désignation</th>
            <th className='col-sm-2'>Quantité</th>
            {/* <th className="col-sm-2">Observation</th> */}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, i) => (
            <tr key={i}>
              <td>
                <div className=' mn-5 input-group-sm'>
                  <label>{row.number}</label>
                </div>
              </td>
              <td>
                <div className='w-100 mn-3 input-group-sm'>
                  <textarea
                    rows='2'
                    className='form-control'
                    type='text'
                    name='designation'
                    value={row.designation}
                    onChange={handleChange}
                    data-row-index={i}
                  />
                </div>
              </td>
              <td>
                <div className='w-100 mn-3 input-group-sm'>
                  <input
                    type='number'
                    name='quantity'
                    value={row.quantity}
                    onChange={handleChange}
                    data-row-index={i}
                    className='form-control'
                  />
                </div>
              </td>
              {/* <td>
                <div className="mn-3 input-group-sm">
                  <textarea
                    type="text"
                    name="observation"
                    value={row.observation}
                    onChange={handleChange}
                    data-row-index={i}
                    className="form-control"
                  />
                </div>
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <form onSubmit={handleSubmit} className="form-control">
      {renderTable()}
      <Button variant="primary" onClick={handleAddRow}>
        +
      </Button>
    </form>
  );
};

export default TableForm;
